import React from 'react';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import Icon2 from '../ReactIcons/icon2';
import { ICON_ANCHOR, ICON_SIZE } from '.';

const mapIcon2 = L.divIcon({
    html: ReactDOMServer.renderToString(<Icon2 />),
    iconSize: ICON_SIZE,
    iconAnchor: ICON_ANCHOR
});

export default mapIcon2;